import * as q from '@/services/api/request/query';
import { encodePaginatableQuery, PaginatableQuery, Query } from '../../request';

export interface MeasurementsQuery extends PaginatableQuery {
  from: Date;
  to: Date;
}

export const encodeMeasurementsQuery = (query: MeasurementsQuery): Query => ({
  ...encodePaginatableQuery(query),
  from: q.date(query.from),
  to: q.date(query.to),
});
